import React, { Component } from 'react';
import axios from 'axios';
import { Button, Form, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import { FiltersOnStyle, HeaderCursor } from './ProfessorInputGrades/css';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

class FilterStudentsForProfessor extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            firstName: '',
            lastName: '',
            index: '',
            filterData: [],
            loading: false,
            showStudentInfo: false
        };
        this.getStudents = this.getStudents.bind(this);
    }

    getStudents() {
        const { firstName, lastName, index } = this.state;

        if (!firstName && !lastName && !index) {
            toast('Morate unijeti bar jedan filter.');
            return;
        }
        this.setState({ loading: true });
        let docFilter = {};

        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (index) docFilter = { ...docFilter, index };

        axios.post(`professor/students-enrolled-in-all-professors-implementations/${window.$locale}`, { ...docFilter })
            .then(res => {
                const filterData = res.data.map(el => ({
                    ...el,
                    studyType: el.studyTypeId ? this.state.studyTypes.find(e => e.id === el.studyTypeId).name : null,
                    studentStatus: el.studentStatusId ? this.state.studentStatuses.find(e => e.id === el.studentStatusId).name : null
                }));
                this.setState({ filterData, loading: false, showMessage: true });
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }


    render() {
        return (
            <div>
                {/* <h1>Filtriranje studenata</h1> */}
                <h1> <FormattedMessage id="common.students" /></h1>
                <Segment.Group raised>
                    <Segment>
                        <h3><FormattedMessage id="common.filterStudents" /></h3>
                    </Segment>
                    <Segment clearing>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label><FormattedMessage id="common.firstName" /></label>
                                    <FormattedMessage id="common.inputName">
                                        {(msg) => (<input
                                            value={this.state.firstName}
                                            onChange={(e) => this.setState({ firstName: e.target.value })}
                                            name="firstName"
                                            placeholder={msg}
                                        />)}
                                    </FormattedMessage>

                                </Form.Field>
                                <Form.Field>
                                    <label><FormattedMessage id="common.lastName" /></label>
                                    <FormattedMessage id="common.inputLastName">
                                        {(msg) => (<input
                                            value={this.state.lastName}
                                            onChange={(e) => this.setState({ lastName: e.target.value })}
                                            name="lastName"
                                            placeholder={msg}
                                        />)}
                                    </FormattedMessage>

                                </Form.Field>
                                <Form.Field>
                                    <label><FormattedMessage id="common.index" /></label>
                                    <FormattedMessage id="common.inputIndex">
                                        {(msg) => (<input
                                            value={this.state.index}
                                            onChange={(e) => this.setState({ index: e.target.value })}
                                            name="index"
                                            placeholder={msg}
                                        />)}
                                    </FormattedMessage>

                                </Form.Field>

                            </Form.Group>

                            <Button floated="right" color="blue" onClick={this.getStudents}><FormattedMessage id="professorInputGrades.showStudents" /></Button>
                        </Form>

                    </Segment>
                    <Segment>
                        {!this.state.loading ?
                            <div>
                                { this.state.filterData.length ? <Table celled selectable compact >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell width="4"><FormattedMessage id="common.lastNameAndFirstName" /></Table.HeaderCell>
                                            <Table.HeaderCell width="2"><FormattedMessage id="common.index" /></Table.HeaderCell>
                                            <Table.HeaderCell><FormattedMessage id="professorInputGrades.department" /></Table.HeaderCell>
                                            <Table.HeaderCell><FormattedMessage id="professorInputGrades.studyProgram" /></Table.HeaderCell>
                                            <Table.HeaderCell />
                                        </Table.Row>
                                    </Table.Header>
                                    {/*    <Popup */}
                                    {/*    trigger={ */}
                                    {/*        */}
                                    {/*        } */}
                                    {/*    content="Prikaz informacija o studentu" */}
                                    {/*    hideOnScroll */}
                                    {/*    position="left center" */}
                                    {/* /> */}
                                    <Table.Body> {this.state.filterData.map((el, index) =>
                                        (


                                            <Table.Row
                                                key={index}
                                                style={HeaderCursor}
                                                // onClick={() => {
                                                //     this.setState({ student: el, showStudentInfo: true });
                                                //     localStorage.setItem('student', JSON.stringify(el));
                                                //     localStorage.setItem('orgUnit', JSON.stringify(el.organizationalUnitId));
                                                // }}
                                            >
                                                <Table.Cell verticalAlign="middle" width="4">
                                                    {el.lastName} {el.firstName}
                                                    {el.locked === 1 ? <span style={{ float: 'right' }}> <Icon name="lock" color="blue" /></span> : null}
                                                    {el.studyProgramStudentSwitchedToId ? <span style={{ float: 'right' }}> <Icon name="check" color="blue" /></span> : null}
                                                    {el.dateOfAbandonment !== null ? <span style={{ float: 'right' }}> <Icon name="sign-out" color="red" /></span> : null}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" width="2">
                                                    {el.index}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.departmentsSPOU[0].organizationalUnitName}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" textAlign="center">
                                                    <FormattedMessage id="route.studentsInfoFromSearch">
                                                        {(msg) => (<Link style={{ textDecoration: 'none' }} to={{ pathname: msg, state: { studentId: el.studentId, sspId: el.id, studyProgramId: el.studyProgramId, } }}>
                                                            <Button
                                                                style={FiltersOnStyle}
                                                                size="medium"
                                                                color="blue"
                                                                basic
                                                            ><FormattedMessage id="professorInputGrades.info" /></Button>
                                                        </Link>)}
                                                    </FormattedMessage>
                                                </Table.Cell>


                                            </Table.Row>

                                        ))}
                                    </Table.Body>
                                </Table>

                                    : this.state.showMessage && <FormattedMessage id="professorStatistics.noStudents" />}
                            </div>
                            : <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> }
                    </Segment>

                </Segment.Group>
                <ToastContainer hideProgressBar />


            </div>
        );
    }
}

export default FilterStudentsForProfessor;



// WEBPACK FOOTER //
// ./src/views/Professor/FilterStudentsForProfessor.js